import React from "react";

export const PlusIcon = ({ color }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 5V19M5 12H19" stroke={color || "#000"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
